import axios from 'axios';

export default {

  async search() {
    return axios.get('/api/v1/locations');
  },

};
